export default "__VITE_ASSET__kp$ewGv$__"